export default function is24TimeValid(time: string): boolean {
  // Expressão regular para verificar o formato do horário (HH:mm)
  const timeRegex = /^([01]\d|2[0-3]):[0-5]\d$/;

  // Testa se a string fornecida corresponde ao formato de um horário válido
  return timeRegex.test(time);
}
